import Config from "../config";
import CryptoJS from "crypto-js";
import store from "../store";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

export const authenticatedFetch = async (path, options = {}) => {
	if (!options.headers) {
		options.headers = {
			"Content-Type": "application/json",
			Accept: "application/json"
		};
	}
	options.headers["Authorization"] = `Bearer ${localStorage.token}`;
	try {
		const response = await fetch(Config.backend_url + path, options);

		if (!response.ok) {
			// Si la réponse n'est pas OK (200-299), rejeter la promesse avec une erreur
			const errorMessage = `Un problème est survenu`;
			store.state.toast = {
				status: "error",
				text: errorMessage
			};
			throw new Error(errorMessage);
		}

		return response;
	} catch (error) {
		// Si une erreur se produit, affichez-la dans votre toast
		store.state.toast = {
			status: "error",
			text: "Un problème est survenu"
		};
		throw error;
	}
};

export const studentFetch = async (path, options = {}) => {
	if (!options.headers) {
		options.headers = {
			"Content-Type": "application/json",
			Accept: "application/json"
		};
	}
	options.headers["Authorization"] = `Student Bearer ${localStorage.getItem(
		"studentToken"
	)}`;
	try {
		const response = await fetch(Config.backend_url + path, options);

		if (!response.ok) {
			// Si la réponse n'est pas OK (200-299), rejeter la promesse avec une erreur
			const errorMessage = `Un problème est survenu`;
			store.state.toast = {
				status: "error",
				text: errorMessage
			};
			throw new Error(errorMessage);
		}

		return response;
	} catch (error) {
		// Si une erreur se produit, affichez-la dans votre toast
		store.state.toast = {
			status: "error",
			text: "Un problème est survenu"
		};
		throw error;
	}
};

export const authenticatedApiFetch = async (path, options = {}) => {
	return await authenticatedFetch("/api/v1" + path, options);
};

export const authenticatedImageFetch = (path, options = {}) => {
	return authenticatedFetch("/media/" + path, options);
};

export const authenticatedStudentImageFetch = (path, options = {}) => {
	return studentFetch("/media/" + path, options);
};

export const authenticatedStudentApiFetch = async (path, options = {}) => {
	return await studentFetch("/api/v1" + path, options);
};

export const decodeAndStoreToken = token => {
	let base64Url = token.split(".")[1];
	let base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
	let jsonPayload = decodeURIComponent(
		atob(base64)
			.split("")
			.map(function (c) {
				return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
			})
			.join("")
	);
	localStorage.token = token;
	localStorage.userId = JSON.parse(jsonPayload).user_id;
	localStorage.profileId = JSON.parse(jsonPayload).profil;

	return {
		token: localStorage.token,
		userId: localStorage.userId,
		profileId: localStorage.profile
	};
};

export const random = (string, values) => {
	// Replace variables by random values
	if (values != null) {
		if (Object.keys(values).length != 0) {
			if (string != null) {
				let random_values = values;
				string = string.replace(/%.*?%/, "");
				for (const key in random_values) {
					string = string.replaceAll(key, random_values[key]);
				}
				if (string.match(/\\calc{(.*?)}/g)) {
					string = getMathValues(string);
				}
			}
		}
	}
	return string;
};

export const getMathValues = string => {
	if (string.match(/\\calc{(.*?)}/g)) {
		let calc_values = string.match(/\\calc{(.*?)}/g);
		let final_values = [];

		for (let i = 0; i < calc_values.length; i++) {
			let calc = calc_values[i].split(/\\calc{(.*?)}/);
			calc = calc[1].split(";");
			calc = calculate(
				Number(calc[0].replace(",", ".")),
				calc[1],
				Number(calc[2].replace(",", "."))
			);
			final_values.push(calc.toString().replace(".", ","));
		}
		calc_values.map((key, value) => {
			string = string.replace(key, final_values[value]);
		});
		return string;
	}
};

export const calculate = (x, operator, y) => {
	// Do basic math operations (+, -, /, *)
	let sum;
	switch (operator) {
		case "+":
			sum = Math.round((x + y) * 100) / 100;
			break;
		case "-":
			sum = Math.round((x - y) * 100) / 100;
			break;
		case "/":
			sum = Math.round((x / y) * 100) / 100;
			break;
		case "*":
			sum = Math.round(x * y * 100) / 100;
			break;
		case "^":
			sum = Math.pow(x, y);
			break;
		default:
			return sum;
	}
	return sum;
};

export const image = (string, data) => {
	// Replace \picture by an image
	var image = null;
	if (string) {
		if (string.match(/\\picture(.*?)/g)) {
			image = string.match(/\\picture(.*?)/g);
		}
	}
	if (image === null) {
		return string;
	}
	let newImage = '<img class="inside-img" src="' + data + '" alt="" />';
	string = string.replace(image, newImage);
	return string;
};

export const translateFromTexToHTML = string => {
	// Search & Replace LaTeX expressions
	let parserRules = [
		{ tex: "\\begin{center}", html: "<center>" },
		{ tex: "\\end{center}", html: "</center>" },
		{ tex: "\\begin{tabularx}", html: "\\begin{array}" },
		{ tex: "\\end{tabularx}", html: "\\end{array}" },
		{ tex: "\\begin{enumerate}", html: "<ol>" },
		{ tex: "\\end{enumerate}", html: "</ol>" },
		{ tex: "\\textbf", html: "\\mathbf" },
		{ tex: "{\\linewidth}", html: "" }
	];

	for (let i = 0; i < parserRules.length; i += 1) {
		var re = RegExp("\\" + parserRules[i].tex + "(?![a-zA-Z])", "g");
		if (!re) {
			return string;
		}
		string = string.replace(re, parserRules[i].html);
	}
	return string;
};

export const formateAndOrderDate = courses => {
	courses = courses.sort(function (a, b) {
		return (
			new Date(`${a.day} ${a.debut_hour}`) -
			new Date(`${b.day} ${b.debut_hour}`)
		);
	});
	for (const course of courses) {
		const date = new Date(course.day);
		course.formatedDay = date.toLocaleDateString("fr", {
			weekday: "long",
			day: "2-digit",
			month: "long"
		});
		course.debut_hour = course.debut_hour.slice(0, -3);
		course.end_hour = course.end_hour.slice(0, -3);
	}

	return courses;
};

export const crypt = e => {
	const encrypted = CryptoJS.AES.encrypt(e, Config.secret_key).toString();
	return encrypted;
};

export const decrypt = e => {
	const bytes = CryptoJS.AES.decrypt(e, Config.secret_key);
	const originalText = bytes.toString(CryptoJS.enc.Utf8);
	return originalText;
};

export const getTileGameInfo = e => {
	switch (e) {
		case "MATH_LA_CITROUILLE":
			return {
				name: "Wander Game",
				img: "/img/game/demo-tile-game-halloween.jpg"
			};
		case "MATH_LA_BANQUISE":
			return {
				name: "Wander Game",
				img: "/img/game/demo-tile-game-winter.jpg"
			};
		case "MATH_LA_PLAGE":
			return {
				name: "Wander Game",
				img: "/img/game/demo-tile-game-summer.jpg"
			};
		case "MATH_L_ESPACE":
			return {
				name: "Wander Game",
				img: "/img/game/demo-tile-game-space.jpg"
			};
		case "MATH_LE_CIEL":
			return {
				name: "Wander Game",
				img: "/img/game/demo-tile-game-sky.jpg"
			};
		case "MATH_LE_SKATE":
			return {
				name: "Wander Game",
				img: "/img/game/demo-tile-game-skate.jpg"
			};
		case "MATH_LE_ROBOT":
			return {
				name: "Wander Game",
				img: "/img/game/demo-tile-game-robot.jpg"
			};
		default:
			return {
				name: "Wander Game",
				img: "/img/game/demo-tile-game-summer.jpg"
			};
	}
};

export const filteredLevels = filter => {
	const classes = store.state.levels.filter(el => {
		return filter.some(f => {
			return f === el.name;
		});
	});
	return classes;
};

export const checkRightFor = (resource, levels) => {
	const currentDate = new Date();

	const freeAccessEnd = new Date("2025-09-27T23:59:00");

	if (currentDate < freeAccessEnd) {
		return true;
	}

	if (
		store.state.user.role == "ADMIN" ||
		store.state.user.role == "SUPER_ADMIN"
	) {
		return true;
	}

	if (
		store.state.freeTrial.free_trial_end &&
		store.state.freeTrial.free_trial_start
	) {
		const freeTrialEndDate = new Date(store.state.freeTrial.free_trial_end);

		if (freeTrialEndDate > currentDate) {
			return true;
		}
	}
	const rights = store.state.rightFor;

	const matchingRight = rights.find(right => {
		return (
			right.resourceType === resource &&
			levels.every(level => right.levels.includes(level))
		);
	});

	if (matchingRight) {
		const subscriptionStart = new Date(matchingRight.subscription_start);
		const subscriptionEnd = new Date(matchingRight.subscription_end);

		if (
			currentDate >= subscriptionStart &&
			currentDate <= subscriptionEnd
		) {
			return true;
		} else {
			return false;
		}
	}
	return matchingRight !== undefined;
};

export const formatedDate = value => {
	const date = new Date(value);
	const options = { year: "numeric", month: "long", day: "numeric" };
	const dateFormat = new Intl.DateTimeFormat("fr-FR", options);
	const formattedDate = dateFormat.format(date);
	return formattedDate;
};

export const getWebsiteIcon = link => {
	const mapping = {
		"https://kahoot.it": "/img/favicon/kahoot.webp",
		"https://www.index-education.com": "/img/favicon/pronote.webp",
		"genial.ly": "/img/favicon/genially.webp",
		"https://www.ecoledirecte": "/img/favicon/ecole-direct.webp",
		"https://landing.lecoinduprof.fr": "/img/favicon/le-coin-du-prof.webp",
		"https://educadhoc.fr": "/img/favicon/educadhoc.webp",
		"https://www.geogebra": "/img/favicon/geogebra.webp",
		"https://manuel.sesamath": "/img/favicon/sesamath.webp",
		"https://www.online-python": "/img/favicon/python-editor.webp",
		"https://scratch": "/img/favicon/scratch.webp",
		"lumni.fr": "/img/favicon/lumni.webp",
		"https://www.canva.com": "/img/favicon/canva.webp",
		"https://padlet.com": "/img/favicon/padlet.webp",
		"https://bouncyballs.org": "/img/favicon/bouncyballs.webp",
		"https://plagiarismdetector.net":
			"/img/favicon/plagiarismdetector.webp",
		"https://www.edumedia.com": "/img/favicon/edumedia.webp",
		"https://www.solumaths.com": "/img/favicon/solumaths.webp",
		"https://www.desmos.com": "/img/favicon/desmos.webp",
		"https://www.fizziq.org": "/img/favicon/fizziq.webp",
		"https://ptable.com": "/img/favicon/ptable.webp",
		"https://chemix.org": "/img/favicon/chemix.webp",
		"https://www.biorender.com": "/img/favicon/biorender.webp",
		"https://tophonetics.com/fr": "/img/favicon/tophonetics.webp",
		"https://www.gingersoftware.com": "/img/favicon/ginger.webp",
		"https://wordart.com/": "/img/favicon/wordart.webp",
		"https://wordsift.org/": "/img/favicon/wordsift.webp",
		"https://www.cervantesvirtual.com/": "/img/favicon/cervantes.webp",
		"https://conjugaison.tatitotu.ch/": "/img/favicon/conjugaison.webp",
		"https://languagetool.org/fr/": "/img/favicon/languagetool.webp",
		"https://www.weblettres.net/": "/img/favicon/weblettres.webp",
		"https://www.timetoast.com/": "/img/favicon/timetoast.webp",
		"https://storymap.knightlab.com/": "/img/favicon/storymap.webp",
		"https://geteach.com/": "/img/favicon/geteach.webp",
		"https://paintmaps.com/": "/img/favicon/paintmaps.webp"
	};

	for (const sousChaine in mapping) {
		if (link.includes(sousChaine)) {
			return mapping[sousChaine];
		}
	}

	return link;
};

export const checkIfMathTeacher = () => {
	if (!store.state.subjects) return false;
	const requiredSubjects = ["Maths"];
	const userSubjects = store.state.user.subjects;
	const subjectsName = store.state.subjects
		.filter(subject => userSubjects.includes(subject.id))
		.map(subject => subject.name);
	return requiredSubjects.some(subject => subjectsName.includes(subject));
};

function convertMathFieldToLatex(str) {
	if (!str) return str;
	// Remplace chaque <math-field>...</math-field> par \( ... \)
	return str.replace(
		/<math-field[^>]*>(.*?)<\/math-field>/g,
		(_, latex) => `\\(${latex}\\)`
	);
}

function makeHeader(title) {
	return `
        <div style="display:flex; justify-content: center; margin-bottom: 32px;">
            <h1 style="font-weight:700; text-align:center;" width:100%>
                ${title}
            </h1>
        </div>
        <div style="display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 12px;">
            <div>
                <div style="margin-bottom: 4px;">Nom :</div>
                <div>Prénom :</div>
            </div>
            <div style="text-align: right; padding-right:50px">
                Classe :
            </div>
        </div>
        <table style="width:100%; border-collapse:collapse; margin-bottom: 24px;">
            <tr>
                <td style="width:25%; border:1px solid #ccc; padding:8px; font-weight:bold; vertical-align:top;">Note</td>
                <td style="width:75%; border:1px solid #ccc; padding:60px;"></td>
            </tr>
        </table>
    `;
}

function createPage(PAGE_WIDTH, withHeader, headerTitle) {
	const page = document.createElement("div");
	page.style.position = "absolute";
	page.style.left = "0";
	page.style.top = "0";
	page.style.zIndex = "-1000";
	page.style.background = "#fff";
	page.style.padding = "50px";
	page.style.width = PAGE_WIDTH + "px";
	page.style.fontSize = "16px";
	page.style.fontFamily = "Inter";
	page.innerHTML = withHeader ? makeHeader(headerTitle) : "";
	document.body.appendChild(page);
	return page;
}

async function renderMathJax(pages) {
	for (const page of pages) {
		if (window.MathJax && window.MathJax.typesetPromise) {
			await window.MathJax.typesetPromise([page]);
		} else if (
			window.MathJax &&
			window.MathJax.Hub &&
			window.MathJax.Hub.Queue
		) {
			await new Promise(resolve => {
				window.MathJax.Hub.Queue([
					["Typeset", window.MathJax.Hub, page],
					resolve
				]);
			});
		}
	}
}

async function generatePDF(pages, pdfTitle, fileType) {
	const pdf = new jsPDF({
		orientation: "portrait",
		unit: "px",
		format: "a4"
	});
	const pageWidth = pdf.internal.pageSize.getWidth();

	for (let i = 0; i < pages.length; i++) {
		const canvas = await html2canvas(pages[i], { scale: 2, useCORS: true });
		const imgData = canvas.toDataURL("image/png");
		const ratio = pageWidth / canvas.width;
		const printHeight = canvas.height * ratio;
		if (i > 0) pdf.addPage();
		pdf.addImage(imgData, "PNG", 0, 0, pageWidth, printHeight);
		document.body.removeChild(pages[i]);
	}

	const safeTitle = (pdfTitle || "serie").replace(/[^\w\d-_]+/g, "-");
	pdf.save(`${fileType}-${safeTitle}.pdf`);
}

function makeSimpleHeader(title) {
	return `
        <div style="display:flex; justify-content: center; margin-bottom: 32px;">
            <h1 style="font-weight:700; text-align:center;" width:100%>
                ${title}
            </h1>
        </div>
    `;
}

export const generatedQCMPDF = async (qcm, isCorrection) => {
	const PAGE_PADDING = 100;
	const PAGE_WIDTH = 700;
	const PAGE_HEIGHT_PX = 1122;
	const CONTENT_HEIGHT_PX = PAGE_HEIGHT_PX - PAGE_PADDING;

	const pages = [];

	let headerTitle = isCorrection ? `Correction ${qcm.title}` : qcm.title;
	let currentPage;

	if (isCorrection) {
		// En mode correction, juste le titre
		currentPage = createPage(PAGE_WIDTH, false, "");
		currentPage.innerHTML = makeSimpleHeader(headerTitle);
	} else {
		// En mode sujet, header complet
		currentPage = createPage(PAGE_WIDTH, true, qcm.title);
	}

	for (let qIdx = 0; qIdx < qcm.questions.length; qIdx++) {
		const question = qcm.questions[qIdx];
		const div = document.createElement("div");
		div.style.marginBottom = "18px";
		div.innerHTML = `
            <div style="font-weight:bold;margin-bottom:6px;">Question ${qIdx +
			1}</div>
            <div style="margin-bottom:6px;">${convertMathFieldToLatex(
				question.question
			)}</div>
            <ul style="list-style:none;padding-left:0;">
                ${question.answers
				.map(
					answer => `
                    <li style="margin-bottom:4px;">
                        <input type="checkbox" ${isCorrection && answer.is_correct ? "checked" : ""
						} disabled style="margin-right:6px;transform:scale(1.2);"/>
                        <span>${convertMathFieldToLatex(answer.answer)}</span>
                    </li>
                `
				)
				.join("")}
            </ul>
        `;
		currentPage.appendChild(div);

		if (currentPage.offsetHeight > CONTENT_HEIGHT_PX) {
			currentPage.removeChild(div);
			pages.push(currentPage);
			currentPage = createPage(PAGE_WIDTH, false, "");
			currentPage.appendChild(div);
		}
	}
	pages.push(currentPage);

	await renderMathJax(pages);
	await generatePDF(pages, headerTitle, "Qcm");
};

export const generatedQuestionsPDF = async (
	data,
	isCorrection = true,
	chapter_name = ""
) => {
	console.log(data);
	const PAGE_PADDING = 100;
	const PAGE_WIDTH = 700;
	const PAGE_HEIGHT_PX = 1122;
	const CONTENT_HEIGHT_PX = PAGE_HEIGHT_PX - PAGE_PADDING;

	let questions = [];
	let baseTitle = chapter_name || "";
	let headerTitle = isCorrection ? `Correction ${baseTitle}` : baseTitle;

	if (data.activities && Array.isArray(data.activities)) {
		questions = data.activities;
	} else if (Array.isArray(data)) {
		questions = data;
	} else {
		throw new Error("Format de données non supporté");
	}

	const pages = [];
	let currentPage;

	if (isCorrection) {
		// En mode correction, juste le titre
		currentPage = createPage(PAGE_WIDTH, false, "");
		currentPage.innerHTML = makeSimpleHeader(headerTitle);
	} else {
		// En mode sujet, header complet
		currentPage = createPage(PAGE_WIDTH, true, baseTitle);
	}

	for (let qIdx = 0; qIdx < questions.length; qIdx++) {
		const question = questions[qIdx];
		const div = document.createElement("div");
		div.style.marginBottom = "18px";
		div.innerHTML = `
            <div style="font-weight:bold;margin-bottom:6px;">Question ${qIdx +
			1}${question.title ? " : " + question.title : ""}</div>
            <div style="margin-bottom:6px;">${convertMathFieldToLatex(
				question.description || question.question || ""
			)}</div>
            ${isCorrection && question.correction
				? `
                <div style="margin-bottom:6px;color:green;"><b>Correction :</b> ${convertMathFieldToLatex(
					question.correction
				)}</div>
            `
				: ""
			}
        `;
		currentPage.appendChild(div);

		if (currentPage.offsetHeight > CONTENT_HEIGHT_PX) {
			currentPage.removeChild(div);
			pages.push(currentPage);
			currentPage = createPage(PAGE_WIDTH, false, "");
			currentPage.appendChild(div);
		}
	}
	pages.push(currentPage);

	await renderMathJax(pages);
	await generatePDF(pages, headerTitle, "Question-flash");
};
